import React from "react";
import { useHistory, Redirect } from "react-router";

import useAuth from "../routes/login/AuthContext";
import { LOGIN_URL } from "../routes/login/container/LoginContainer";

const LoggedInLayout = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const history = useHistory();

  if (!isLoggedIn()) {
    if (history.location.pathname !== "/") {
      return (
        <Redirect to={LOGIN_URL} />
      );
    }
  }

  return (
    <>
      {children}
    </>
  );
};

export default LoggedInLayout;
